import React from 'react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-navy-800 px-5 py-16 sm:py-20" data-id="element-143" data-mp="2ln2ee50o55nw">
      <div className="mx-auto max-w-5xl" data-id="element-144" data-mp="2lmj1j2pvl7gq">
        <h2 className="mx-auto max-w-2xl text-center font-display text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-145" data-mp="26yxvp11m8u54">
          If you coach cricket, you're probably living one of these problems:
        </h2>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-146" data-mp="1xwomqflzx8tu">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-lg border border-alert/25 bg-alert/5 px-4 py-4 text-sm leading-relaxed text-white/80" data-id="element-147" data-mp="220e8yyf77ebp">
              <span aria-hidden="true" className="mt-0.5 shrink-0" data-id="element-148" data-mp="1szpu61hzd9xr">
                ❌
              </span>
              {point}
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-xl font-extrabold leading-snug text-gold sm:text-2xl" data-id="element-149" data-mp="3ncfoulg6an67">
          How many more sessions do you want to keep improvising?
        </p>
      </div>
    </section>;
}